// Interface

import { setWithdrawPassword, upadateUser } from "@/api/profile"
import { useUserStore } from "@/stores/user"
import { playClickSound } from "@/utils/media"
import { Ref } from "vue"
import { Router, useRouter } from "vue-router"

export interface ProfilePoupData {
    show: boolean
    isPopping: boolean
    componentList: any[]
    componentIdsInOrderConfig: any
}

export interface ProfileSettingData {
    nickName: string
    loginAccount: string
    avatarImg: string
}

export interface AvatarData {
    avatarImg: string
}

export interface ContactItem {
    avatar: string
    nickname: string
    redirectUrl: string
    contactAccount: string
}

export interface ContactServiceData {
    serviceList : ContactItem[]
    show: boolean
}

// Constant
export const ICON_IMG = [{ img: require('@/assets/profile/user.png') },
{ img: require('@/assets/profile/phone.png') },
{ img: require('@/assets/profile/email.png') },
{ img: require('@/assets/profile/id.png') },]

export const MENU_LIST = [{ name: 'profile.rapporteurs', img: require('@/assets/profile/personal_registrodoJogo.png'), path: '/sd-gamelog' },
{ name: 'profile.toInvite', img: require('@/assets/profile/personal_convidar.png'), msg: 'profile.treasureMsg', path: '/sdagency' },
{ name: 'profile.redemptionCode', img: require('@/assets/profile/personal_logout.png'), path: '/giftcode' },
{ name: 'profile.support', img: require('@/assets/profile/personal_kefu_lan.png'), path: 'CHAT' },
{ name: 'profile.securityCenter', img: require('@/assets/profile/personal_setting.png'), path: '/sd-profile' },
{ name: 'profile.fundHistory', img: require('@/assets/profile/personal_registrodoJogo.png'), path: '/fundsHistory' },
{ name: 'profile.goOut', img: require('@/assets/profile/personal_logout.png'), path: 'logout' }
]
export const MENU_LIST_THEME_TWO = [{ name: 'profile.rapporteurs', img: require('@/assets/themetwo/headUser_4.png'), path: '/sd-gamelog' },
{ name: 'profile.toInvite', img: require('@/assets/themetwo/headUser_2.png'), msg: 'profile.treasureMsg', path: '/sdagency' },
{ name: 'profile.redemptionCode', img: require('@/assets/themetwo/headUser_1.png'), path: '/giftcode' },
{ name: 'profile.support', img: require('@/assets/themetwo/headUser_5.png'), path: 'CHAT' },
{ name: 'profile.securityCenter', img: require('@/assets/themetwo/headUser_6.png'), path: '/sd-profile' },
{ name: 'profile.fundHistory', img: require('@/assets/themetwo/headUser_4.png'), path: '/fundsHistory' },
{ name: 'profile.goOut', img: require('@/assets/themetwo/headUser_7.png'), path: 'logout' }
]
export const MENU_LIST_THEME_THREE = [{ name: 'profile.rapporteurs', img: require('@/assets/themeThree/report.png'), path: '/sd-gamelog' },
{ name: 'profile.toInvite', img: require('@/assets/themeThree/addMem.png'), msg: 'profile.treasureBonusMsg',isHaveIcons:true, path: '/sdagency' },
{ name: 'profile.redemptionCode', img: require('@/assets/themeThree/redCode.png'), path: '/giftcode' },
{ name: 'profile.support', img: require('@/assets/themeThree/support.png'), path: 'sd-message',isSupport:true },
{ name: 'profile.securityCenter', img: require('@/assets/themeThree/security.png'), path: '/sd-profile' },
{ name: 'profile.fundHistory', img: require('@/assets/themeThree/addMem.png'), path: '/fundsHistory' },
{ name: 'profile.goOut', img: require('@/assets/themeThree/logout.png'), path: 'logout' }
]
export const MENU_LIST_THEME_FOUR = [{ name: 'profile.rapporteurs', img: require('@/assets/themeFour/report.png'), path: '/sd-gamelog' },
{ name: 'profile.toInvite', img: require('@/assets/themeFour/addMem.png'), msg: 'profile.treasureBonusMsg',isHaveIcons:true, path: '/agent' },
{ name: 'profile.redemptionCode', img: require('@/assets/themeFour/redCode.png'), path: '/giftcode' },
{ name: 'profile.securityCenter', img: require('@/assets/themeFour/security.png'), path: '/sd-profile' },
{ name: 'profile.goOut', img: require('@/assets/themeFour/logout.png'), path: 'logout' }
]
export const SUPPORT_CHAT_MENU = [
    { name: 'profile.support', img: require('@/assets/themeFour/chat.png'), path: 'CHAT', isSupport:true }
]

// Fuctions
export const showError = (
    toastContent: Ref<string>,
    isSuccess: Ref<boolean>,
    statusRef: Ref<{ open: () => void } | null>,
    message: string
) => {
    toastContent.value = message
    isSuccess.value = false
    statusRef.value?.open()
}


export const showSuccess = (
    toastContent: Ref<string>,
    isSuccess: Ref<boolean>,
    statusRef: Ref<{ open: () => void } | null>,
    message: string
) => {
    toastContent.value = message
    isSuccess.value = true
    statusRef.value?.open()
}


export const updateNickName = async (
    id: string | number,
    userName: string,
    show: Ref<boolean>,
    toastContent: Ref<string>,
    isSuccess: Ref<boolean>,
    statusRef: Ref<{ open: () => void } | null>
) => {
    try {
        const data = {
            uid: id,
            change_item: 'nickname',
            change_value: userName,
        }

        const res = await upadateUser(data)
        showSuccess(toastContent, isSuccess, statusRef, res.msg)

        const userStore = useUserStore()
        userStore.getInfo()

        setTimeout(() => {
            show.value = false
        }, 500)
    } catch (err: any) {
        showError(toastContent, isSuccess, statusRef, err)
    }
}


export const updatePassword = async (
    id: string | number,
    password: string,
    show: Ref<boolean>,
    toastContent: Ref<string>,
    isSuccess: Ref<boolean>,
    statusRef: Ref<{ open: () => void } | null>
) => {
    try {
        const data = {
            uid: id,
            change_item: 'password',
            change_value: password,
        }

        const res = await upadateUser(data)
        showSuccess(toastContent, isSuccess, statusRef, res.msg)

        setTimeout(() => {
            show.value = false
            const userStore = useUserStore()
            userStore.signOut()
            location.reload()
        }, 500)
    } catch (err: any) {
        showError(toastContent, isSuccess, statusRef, err)
    }
}

export const checkPasswordValidation = (
    value: string,
    passwordValidationNotice: Ref<boolean>
) => {
    if ((value.length >= 8 && value.length <= 20) || value.length === 0) {
        passwordValidationNotice.value = false
    } else {
        passwordValidationNotice.value = true
    }
}

export const checkWithdrawPasswordValidation = (
    value: string,
    passwordValidationNotice: Ref<boolean>
) => {
    if ((value.length >= 6 && value.length <= 20) || value.length === 0) {
        passwordValidationNotice.value = false
    } else {
        passwordValidationNotice.value = true
    }
}

export const checkConfirmPasswordValidation = (
    value: string,
    confirmPassword: Ref<string>,
    password: Ref<string>,
    passwordMismatchNotice: Ref<boolean>
) => {
    confirmPassword.value = value
    passwordMismatchNotice.value =
        value.length > 0 && value !== password.value
}

export function clickOnCard(router: Router, isPopping: Ref<boolean>, path: string) {
    playClickSound()
    isPopping.value = true
    setTimeout(() => {
        isPopping.value = false
        router.push(path)
    }, 300)
}

export function copyID(statusRef: Ref<any>, value: number) {
    if (value) {
        navigator.clipboard.writeText(value.toString())
        statusRef.value.open()
    }
}

export function buttonClick(router: Router, type: string) {
    playClickSound()
    if (type === 'topup') {
        router.push('/sd-topup')
    } else if (type === 'withdraw') {
        router.push('/sd-withdraw')
    }
}

export function clickOnMenu(
    router: Router,
    poppingIndex: Ref<number | null>,
    contactServiceRef: Ref<any>,
    handleLogoutClick: () => void,
    path: string | null,
    index: number
) {
    playClickSound()
    poppingIndex.value = index

    setTimeout(() => {
        poppingIndex.value = null
        if (!path) return

        if (path === 'CHAT') {
            contactServiceRef.value.open()
        } else if (path === 'logout') {
            handleLogoutClick()
        } else {
            router.push(path)
        }
    }, 300)
}
export function clickOnMenuThemeThree(
    router: Router,
    poppingIndex: Ref<number | null>,
    contactServiceRef: Ref<any>,
    handleLogoutClick: () => void,
    path: string | null,
    index: number
) {
    playClickSound()
    poppingIndex.value = index

    setTimeout(() => {
        poppingIndex.value = null
        if (!path) return

        if (path === 'logout') {
            handleLogoutClick()
        } else {
            router.push(path)
        }
    }, 300)
}

export function clickOnMenuThemeFour(
    router: Router,
    poppingIndex: Ref<number | null>,
    contactServiceRef: Ref<any>,
    handleLogoutClick: () => void,
    path: string | null,
    index: number
) {
    playClickSound()
    poppingIndex.value = index

    setTimeout(() => {
        poppingIndex.value = null
        if (!path) return
        if (path === 'logout') {
            handleLogoutClick()
        } else {
            router.push(path)
        }
    }, 300)
}

export function goToUrl(url: string): void {
  if (!url) return
  window.open(url, '_blank')
}

export const updateWithdrawPassword = async (
    oldPassword: string,
    password: string,
    show: Ref<boolean>,
    toastContent: Ref<string>,
    isSuccess: Ref<boolean>,
    statusRef: Ref<{ open: () => void } | null>
) => {
    const userStore = useUserStore()
    try {
        const data = {
            newWithdrawPassword: password,
            oldWithdrawPassword: oldPassword,
            withdrawPasswordType: userStore.withdrawPassword ? 2 : 1
        }

        const res = await setWithdrawPassword(data)
        showSuccess(toastContent, isSuccess, statusRef, res.msg)

        setTimeout(() => {
            show.value = false
            userStore.getInfo()
        }, 500)
    } catch (err: any) {
        showError(toastContent, isSuccess, statusRef, err)
    }
}